import { z, ZodType } from 'zod';
import { zObject } from '../../util/zod';

import { WidgetsName, WidgetType } from './common';

export const widgetCalendarCalDavContentSchema = z.object({
    calEventsLimit: z.boolean().optional(),
    calEventsLimitValue: z.number().optional(),
    calEventsPromptStatus: z.string().optional(),
});

export type WidgetCalendarCalDavContent = z.infer<typeof widgetCalendarCalDavContentSchema>;

export type WidgetCalendarCalDavType = {
    name: WidgetsName.CalendarCalDav;
    uniqid: string;
    content: WidgetCalendarCalDavContent;
};
export const widgetCalendarCalDavTypeSchema: ZodType<WidgetType<WidgetCalendarCalDavContent>> =
    zObject<WidgetCalendarCalDavType>({
        name: z.literal(WidgetsName.CalendarCalDav),
        uniqid: z.string(),
        content: widgetCalendarCalDavContentSchema,
    }) satisfies ZodType<WidgetType<WidgetCalendarCalDavContent>>;
